import { css } from '@emotion/react'
import { SContainer } from './DigitalLegacyAuthor.styled'
import { DigitalLegacyAuthorItem } from 'components/digitalLegacy/digitalLegacyAuthor/digitalLegacyAuthorItem/DigitalLegacyAuthorItem'

import { Title, Title_h2_default } from 'components/Typography'

import { forwardRef } from 'react'
import { pxToRem } from 'utils/styled'

export const DigitalLegacyAuthor = forwardRef<
  HTMLDivElement,
  {
    title?: string | null
    authors?:
      | {
          name?: string | null
          photo?: string | null
          description?: string | null
          facebookUrl?: string | null
          linkedinUrl?: string | null
          twitterUrl?: string | null
          instagramUrl?: string | null
        }[]
      | null
    className?: string
  }
>((props, ref) => {
  return (
    <div ref={ref} css={{ padding: `${pxToRem(70)}rem 0` }} className={props.className}>
      <SContainer space={`${pxToRem(55)}rem`}>
        <Title variant={Title_h2_default} as="h2">
          {props.title}
        </Title>

        <div
          css={css`
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(${pxToRem(250)}rem, 1fr));
            grid-gap: ${pxToRem(120)}rem;
          `}
        >
          {props.authors?.map((item, index) => (
            <DigitalLegacyAuthorItem
              key={item.name ?? index}
              name={item.name}
              src={item.photo}
              description={item.description}
              social={{
                facebook: item.facebookUrl,
                linkedin: item.linkedinUrl,
                twitter: item.twitterUrl,
                instagram: item.instagramUrl,
              }}
            />
          ))}
        </div>
      </SContainer>
    </div>
  )
})

DigitalLegacyAuthor.displayName = 'DigitalLegacyAuthor'
